import React from "react";
import { Box, Grid, Typography } from "@mui/material";

export interface AllocationsBarLegendsItemProps {
  value: string;
  color: string;
  multiple?: boolean;
}

const AllocationsBarLegendsItem: React.FC<AllocationsBarLegendsItemProps> = ({ value, color, multiple = false }) => {
  return (
    <Grid>
      <Grid container alignItems="center" wrap="nowrap" spacing={2}>
        <Grid>
          <Box width={12} height={12} bgcolor={multiple ? "#000000" : color} border="1px solid #cccccc" />
        </Grid>
        <Grid>
          <Typography noWrap>{multiple ? "Multiple operators" : value}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AllocationsBarLegendsItem;
